@let text = label ?? name;
@if (!insideControl) {
  <!-- the name is also the button's name (an identical name stops Material adding it again as a description) -->
  <button
    type="button"
    class="button-reset toggletip"
    [attr.aria-label]="text"
    [matTooltip]="text"
    [matTooltipShowDelay]="500"
    matTooltipPosition="above">
    <ng-container *ngTemplateOutlet="picture"></ng-container>
  </button>
} @else {
  <!-- the control carries the tooltip, so it also shows on keyboard focus -->
  <span class="avatar">
    <ng-container *ngTemplateOutlet="picture"></ng-container>
  </span>
  <span class="cdk-visually-hidden">{{ text }}</span>
}

<!-- hidden from screen readers: the button's name or the hidden text says who it is -->
<ng-template #picture>
  @if (image) {
    <img
      class="picture"
      [src]="image"
      alt="">
  } @else {
    <span
      class="circle"
      aria-hidden="true">
      {{ initials }}
    </span>
  }
</ng-template>
